import axiosInstance from "../../apiAxios/axiosInstance";


export const AddKyc = async(payload) => {
  const response= await axiosInstance.post("/vendor/vendor-kyc-submit",payload);
   return response.data;
};
export const getKycDetail = async(payload) => {
  const response= await axiosInstance.get("/vendor/vendor-kyc",payload);
   return response.data;
};



